<template>
  <a-drawer
    :title="title"
    :visible="visible"
    :width="900"
    :maskClosable="true"
    :destroyOnClose="true"
    placement="right"
    style="overflow: auto; padding-bottom: 53px"
    @close="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item
          label="公告类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            style="width: 120px"
            @change="handleChange"
            v-decorator="[
              'category',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择公告类型'
                  }
                ]
              }
            ]"
          >
            <a-select-option value="0"> 产品公告 </a-select-option>
            <a-select-option value="1"> 产品资讯 </a-select-option>
            <a-select-option value="2"> 普通公告 </a-select-option>
          </a-select>
          <!-- <j-dict-select-tag
            style="width: 500px;"
            :size="'large'"
            type="list"
            v-decorator="['moduleName']"
            :trigger-change="true"
            dictCode="fund_file"
            placeholder="请选择"
          /> -->
        </a-form-item>
        <a-form-item label="文本类型">
          <a-radio-group
            @change="noticeTypeChange"
            v-decorator="[
              'noticeType',
              {
                initialValue: 1,
                rules: [{ required: true, message: '请选择公告类型' }]
              }
            ]"
          >
            <a-radio :value="1"> 文本 </a-radio>
            <a-radio :value="2"> 文件 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="定期类型">
          <a-radio-group
            @change="regularTypeChange"
            v-decorator="[
              'regularType',
              {
                initialValue: 1,
                rules: [{ required: true, message: '请选择公告类型' }]
              }
            ]"
          >
            <a-radio :value="1"> 定期公告 </a-radio>
            <a-radio :value="0"> 其它公告 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="公告标题">
          <a-input
            size="large"
            :max-length="100"
            style="width: 500px"
            placeholder="请输入公告标题,不超过100个字"
            v-decorator="[
              'title',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入公告标题,不超过100个字'
                  }
                ]
              }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="公告内容" v-if="noticeType == 1">
          <tinymce-editor
            ref="tinymceEditor"
            style="width: 500px"
            @change="getMyValue"
            v-decorator="['content', { initialValue: '' }]"
          />
        </a-form-item>
        <a-form-item label="公告附件">
          <Upload
            :accept="'.zip, .doc, .docx, .pdf'"
            @handleFileList="handleFileList"
            :fileList="attachments"
            :deleteUrl="'wechatwork-content-biz/content/notice/attachment/del'"
          >
          </Upload>
        </a-form-item>
        <a-form-item label="关联产品">
          <a-input
            size="large"
            :max-length="100"
            disabled
            style="width: 500px"
            placeholder="请输入公告标题,不超过100个字"
            v-decorator="[
              'fundCode',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入公告标题,不超过100个字'
                  }
                ]
              }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item
          v-show="noticeType == 2"
          label="文件类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            style="width: 500px"
            :size="'large'"
            type="list"
            v-decorator="['moduleName']"
            :trigger-change="true"
            dictCode="fund_file"
            placeholder="请选择"
          />
        </a-form-item>
        <a-form-item label="发布渠道栏目">
          <a-tree-select
            size="large"
            style="width: 500px"
            ref="notice"
            :tree-data="columnChannel"
            @change="onChange"
            tree-checkable
            placeholder="请选择发布渠道栏目"
            v-decorator="[
              'channelColumnList',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择发布渠道栏目'
                  }
                ]
              }
            ]"
          />
        </a-form-item>
        <!-- <a-form-item label="关联产品">
          <a-select
            mode="multiple"
            placeholder="请选择关联产品"
            style="width: 500px"
            v-decorator="['fundCode']"
            size="large"
            @change="handleReleFund"
          >
            <a-select-option
              v-for="(item, key) in fundList"
              :key="key"
              :value="item.fundCode"
            >
              {{ item.fundCode }}/{{ item.fundName }}
            </a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item label="发布设置">
          <a-radio-group
            v-decorator="[
              'publishType',
              {
                initialValue: 1,
                rules: [{ required: true, message: '请选择发布设置' }]
              }
            ]"
          >
            <a-radio :value="1"> 立即发布 </a-radio>
            <a-radio :value="2"> 定时发布 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="发布时间">
          <a-date-picker
            size="large"
            style="width: 500px"
            :show-time="{ format: 'HH:mm:ss' }"
            v-decorator="[
              'publishTime',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择发布时间'
                  }
                ]
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="失效时间">
          <a-date-picker
            size="large"
            style="width: 420px"
            format="YYYY-MM-DD"
            :disabled="!this.form.getFieldValue('publishTime')"
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
            :disabled-date="disabledDateFailureTime"
            v-decorator="['failTime']"
          />
          <span style="margin-left: 10px; color: #999"
            >*不填则代表永久有效</span
          >
        </a-form-item>
        <a-form-item label="可见权限">
          <a-radio-group v-decorator="['permissionType', { initialValue: 0 }]">
            <a-radio :value="0"> 全部人可见 </a-radio>
            <a-radio :value="1"> 开户人可见 </a-radio>
            <a-radio :value="2"> 持有人可见 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="排序">
          <a-input-number :min="1" v-decorator="['sort']"></a-input-number>
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import { noticeAdd, noticeEdit } from '@/api/api';
import moment from 'moment';
import tinymceEditor from '@/components/tools/tinymceEditor';
import Upload from '@/components/common/Upload';
import { findTreeNodeArray } from '@/utils/common';
export default {
  name: 'noticeManageModal',
  components: {
    JDictSelectTag,
    tinymceEditor,
    Upload
  },
  props: ['columnChannel', 'fundList'],
  data() {
    return {
      fileType: 'file',
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      showDialog: false,
      form: this.$form.createForm(this),
      title: '修改',
      width: 800,
      visible: false,
      model: {},
      confirmLoading: false,
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/contNotice/listResult',
        edit: process.env.VUE_APP_CMS_CONTENT + '/product/notice/add'
      },
      showPp: false,
      originalId: '',
      ppList: [],
      attachments: [], //附件集合
      cacheData: [],
      editingKey: '',
      columnList: [],
      isShow: false,

      noticeType: 1,
      selectFund: [],
      fundCode: ''
    };
  },
  mounted() {
    this.fundCode = this.$route.query.fundCode;
    // this.fundName = fundInfo.fundName;
  },
  methods: {
    regularTypeChange(e) {
      this.regularType = e.target.value;
    },
    //选择公告类型
    handleChange(value) {
      console.log(value);
      this.form.setFieldsValue({
        category: value
      });
    },
    noticeTypeChange(e) {
      this.noticeType = e.target.value;
    },

    getMyValue(val) {
      this.form.setFieldsValue({
        content: val
      });
    },
    //发布渠道栏目
    onChange(value, label, val) {
      console.log(val, value, label);
      this.columnList = value;
      // this.columnList = [];
      // value.forEach((item, index) => {
      //   let obj = {};
      //   obj.channelName = label[index];
      //   obj.columnId = item;
      //   this.columnList.push(obj);
      // });
      console.log(this.columnList);
    },
    moment,
    disabledDateFailureTime(current) {
      if (this.form.getFieldValue('publishTime')) {
        return (
          current <= moment(this.form.getFieldValue('publishTime')).endOf('day')
        );
      }
      return current <= moment().endOf('second');
    },
    add() {
      this.edit({
        noticeType: 1,
        publishSettings: 2,
        category: 0 + ''
      });
      this.$nextTick(() => {
        this.form.setFieldsValue({
          fundCode: this.fundCode
        });
      });
    },
    edit(records) {
      console.warn('>>>>>>', records);
      let obj = JSON.parse(sessionStorage.getItem('productParticulars'));

      this.visible = true;
      this.attachments = [];
      this.selectFund = [];
      this.columnList = [];
      this.form.resetFields();
      let arr = [];
      let record = { ...records };
      if (record.id) {
        record.publishTime =
          record.publishSettings == 2
            ? moment(record.publishTime, 'YYYY-MM-DD HH:mm:ss')
            : null;
        record.failTime = record.failTime
          ? moment(record.failTime, 'YYYY-MM-DD HH:mm:ss')
          : null;
        this.attachments = record.attachments ? record.attachments : [];
        //this.columnList = records.channelColumnList;
        if (records.channelColumnList && records.channelColumnList.length > 0) {
          records.channelColumnList.forEach(item => {
            arr.push(item.columnId);
          });
        }
        this.columnList = arr;
      }
      this.model = Object.assign({}, record);
      this.$nextTick(() => {
        setTimeout(() => {
          this.form.setFieldsValue(
            pick(
              this.model,
              'title',
              'failTime',
              'content',
              'noticeType',
              'permissionType',
              'sort',
              'moduleName'
            )
          );
          this.form.setFieldsValue({
            publishTime: records.publishTime
              ? moment(new Date(records.publishTime))
              : null,
            channelColumnList: arr,
            category: record.category,
            regularType: record.regularType,
            publishType: records.publishType ? records.publishType : 1
          });
          this.form.setFieldsValue({
            fundCode: obj.fundName
          });
        }, 100);
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        let timeObj = {
          publishTime: values.publishTime
            ? moment(values.publishTime).format('YYYY-MM-DD HH:mm:ss')
            : '',
          failTime: values.failTime
            ? moment(values.failTime).format('YYYY-MM-DD HH:mm:ss')
            : ''
        };

        let formData = Object.assign(this.model, values, timeObj);
        formData.channelColumnList = this.handleChannelData(); //this.columnList;
        formData.attachments = this.attachments;
        formData.publishType = values.publishType;
        formData.status = formData.status ? formData.status : 0;
        let productParticularsMessage = JSON.parse(
          sessionStorage.getItem('productParticulars')
        );
        formData.fundCodes = [productParticularsMessage.fundCode];
        formData.fundList = [
          {
            fundCode: productParticularsMessage.fundCode,
            fundName: productParticularsMessage.fundName
          }
        ];
        if (!err) {
          if (!this.model.id) {
            values.urls = '';
            noticeAdd(formData)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.confirmLoading = false;
                  that.$emit('ok');
                } else {
                  that.$message.error(res.message);
                }
              })
              .finally(() => {
                that.confirmLoading = false;
                that.close();
              });
          } else {
            noticeEdit(formData)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.confirmLoading = false;
                  that.$emit('ok');
                } else {
                  that.$message.error(res.message);
                }
              })
              .finally(() => {
                that.confirmLoading = false;
                that.close();
              });
          }
        }
      });
    },
    handleCancel() {
      this.close();
    },
    handleFileList(fileList) {
      let list = fileList;
      if (fileList && fileList.length > 0) {
        list.forEach(item => {
          let obj = {
            attachmentName: item.name,
            attachmentPath: item.fileName
          };
          this.attachments.push(obj);
        });
      } else {
        this.attachments = [];
      }
      console.log(this.attachments);
    },
    handleReleFund(value) {
      let arr = [];
      if (value.length == 0) {
        arr = [];
      } else {
        value.forEach(item => {
          let obj = this.fundList.find(e => e.fundCode == item);
          arr.push({
            fundCode: obj.fundCode,
            fundName: obj.fundName
          });
        });
      }
      this.selectFund = arr;
    },
    handleChannelData() {
      let arr = findTreeNodeArray('children', this.columnChannel, e => {
        return this.columnList.filter(item => item == e.id).length > 0;
      });
      console.log('arr++++++', arr);
      let list = [];
      arr.forEach(item => {
        let obj = {};
        obj.columnName = item.name;
        (obj.columnCode = item.code), (obj.channelCode = item.channelCode);
        obj.columnId = item.value;
        list.push(obj);
      });
      return list;
    }
  }
};
</script>
<style lang="less" scoped>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.select-all {
  position: absolute;
  right: -10px;
  top: -60px;

  button {
    padding-left: 0;
  }
}
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
